<template>
    <div class="panel details">
        <div class="form-header">
            <p class="form-label">{{ $page.props.lang.title || "Account Details" }}</p>
        </div>
        <div class="fields">
            <div class="grid">
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.firstName || 'First name' }}</p>
                    <v-text-field v-model="form.first_name"
                    :error-messages="responseErrors.first_name" @focus="responseErrors.first_name=''"
                    outlined flat dense></v-text-field>
                </div>
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.lastName || 'Last name' }}</p>
                    <v-text-field v-model="form.last_name"
                    :error-messages="responseErrors.last_name" @focus="responseErrors.last_name=''"
                    outlined flat dense></v-text-field>
                </div>
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.birthDate || 'Day of birth' }}</p>
                    <v-menu
                    ref="birthDatePicker"
                    v-model="birthDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="form.birth_date | formatDate" @click:append="birthDatePicker = true"
                            append-icon="mdi-menu-down" outlined flat dense readonly v-bind="attrs" v-on="on"
                            :hide-details="!responseErrors.birth_date" class="birth-date"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="form.birth_date"
                        :min="minBirth" :max="yesterday"
                         :active-picker.sync="activePicker"
                        :first-day-of-week="1" no-title scrollable color="primary">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="birthDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn text color="primary" @click="birthDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.gender || 'Gender' }}</p>
                    <v-select v-model="form.gender" :items="gender" outlined flat dense></v-select>
                </div>
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.email || 'E-mail' }}</p>
                    <v-text-field v-model="form.email"
                    :error-messages="responseErrors.email" @focus="responseErrors.email=''"
                    outlined flat dense></v-text-field>
                </div>
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.phone || 'Phone number' }}</p>
                    <v-text-field v-model="form.phone_number"
                    :placeholder="country_code + 'xxxx...'"
                    :error-messages="responseErrors.phone_number" @focus="responseErrors.phone_number=''"
                    outlined flat dense>
                    </v-text-field>
                </div>
            </div>
            <div class="field-group">
                <p class="label">{{ $page.props.lang.note || 'Note' }}</p>
                <v-textarea v-model="form.note" hint="Hint text" outlined flat dense></v-textarea>
            </div>
        </div>
        <v-btn @click="submitEdit" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
    </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import TrainerLayout from './Layouts/Default'
import EventBus from '@/js/eventbus'

export default {
    metaInfo() {
        return {
            title:  this.$page.props.lang.title || "Trainer details"
        }
    },
    layout: (h, page) => {
      return h(AppLayout, [
        h(TrainerLayout, [page]),
      ])
    },
    props: {
        trainer: Object,
        lang: Object,
        country_code: String
    },
    data() {
        return {
            form: {
                id: this.trainer.id,
                first_name: this.trainer.first_name,
                last_name: this.trainer.last_name,
                email: this.trainer.email,
                phone_number: this.trainer.phone_number,
                gender: this.trainer.gender,
                birth_date: this.trainer.birth_date,
                note: this.trainer.note
            },
            formReset: {
                id: this.trainer.id,
                first_name: this.trainer.first_name,
                last_name: this.trainer.last_name,
                email: this.trainer.email,
                phone_number: this.trainer.phone_number,
                gender: this.trainer.gender,
                birth_date: this.trainer.birth_date,
                note: this.trainer.note
            },
            birthDatePicker: false,
            activePicker: null,
            minBirth: moment().subtract(70, 'years').format('YYYY-MM-DD'),
            yesterday: moment().subtract(1, 'days').format('YYYY-MM-DD'),
            date: moment().format('YYYY-MM-DD'),
            responseErrors: {},
            messageObjects: []
        }
    },
    watch:{
        birthDatePicker (val) {
        val && setTimeout(() => (this.activePicker = 'YEAR'))
      },
    },
    computed: {
        gender() {
            let male = this.lang.male || 'Male';
            let female = this.lang.female || 'Female';
            let other = this.lang.other || 'Other';
            return [
                { text: male, value: 0 },
                { text: female, value: 1 },
                { text: other, value: 2 }
            ]
        },
        formattedDate() {
            let realDate = new Date(this.form.birth_date)
            let month = realDate.getMonth()
            let day = realDate.getDate()
            let year = realDate.getFullYear()
            return day + '.' + month + '.' + year + '.'
        }
    },
    methods: {
        submitEdit() {
            this.sending = true
            this.form.birth_date = this.form.birth_date ? this.form.birth_date.substr(0, 10) : null;
            axios.post('/backoffice/trainers/update', this.form)
                .then(response => {
                    if (response.data.status==="OK") {
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                        this.$parent.$emit('edited', response.data.member)
                        this.formReset = Object.assign({}, this.form)
                    }

                    this.sending = false;
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        }
    }
}
</script>
